export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcea9bbc2f64b8f3a8e294aaff39a8d592076a9a8&name=fetchTypeahead!'